<template>
  <v-container fluid>
    <v-row v-if="logedInUserInfo.rol==3" class="mt-16">
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Tarifas
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda"
              dense
              outlined
              hide-details
              clearable
            ></v-text-field>
            <v-btn
              style="float:right;"
              color="primary"
              dark
              class="ml-2"
              @click="mostrarModalDescuento = true"
              >Nueva tarifa</v-btn
            >
          </v-card-title>
          <v-alert v-if="mostrarErrorCarga" outlined type="error">
            Hubo un problema cargando la información, revise su conexión a internet e intente
            nuevamente.
          </v-alert>
          <v-data-table
            :loading="tableLoading"
            loading-text="Cargando... por favor espere."
            :headers="headers"
            :items="descuentosList"
            :search="search"
          >
            <template #item.primaryMensajeria="{ item }">
              <div v-if="item.TARIFA.Primary">
                {{ formateaMoneda(item.TARIFA.Primary.Mensajeria) }}
              </div>
            </template>
            <template #item.primaryPaqueteria="{ item }">
              <div v-if="item.TARIFA.Primary">
                {{ formateaMoneda(item.TARIFA.Primary.Paqueteria) }}
              </div>
            </template>
            <template #item.economyPaqueteria="{ item }">
              <div v-if="item.TARIFA.Primary">
                {{ formateaMoneda(item.TARIFA.Economy.Paqueteria) }}
              </div>
            </template>
            <template #item.economyMensajeria="{ item }">
              <div v-if="item.TARIFA.Primary">
                {{ formateaMoneda(item.TARIFA.Economy.Mensajeria) }}
              </div>
            </template>
            <template #item.actions="{ item }">
              <v-btn color="blue" @click="editarDescuentos(item)" class="mr-2" text rounded dark>
                Editar
                <v-icon small class="mr-2">
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn color="red" @click="eliminarDescuento(item.ID)" rounded dark text>
                Borrar
                <v-icon small class="mr-2">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbarExito"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      color="blue darken-1"
      ><span style="font-size:20px;">
        {{ mensajeSnackbarExito }} <v-icon medium> mdi-check-circle </v-icon>
      </span></v-snackbar
    >
    <ModalDescuento
      @cerrar-modal-descuento="cerrarModalDescuento()"
      @muestraModalErrorEnAccion="mostrarModalErrorEnAccion($event)"
      :show="mostrarModalDescuento"
      v-if="mostrarModalDescuento"
      @muestraDialogExito="mostrarDialogExito($event)"
      :descuentoPasado="objetoDescuentoAEditar"
    />
    <ModalConfirmarEliminacion
      :show="dialogConfirmarEliminacion"
      v-if="dialogConfirmarEliminacion"
      @cerrarModalFraccion="dialogConfirmarEliminacion = false"
      @confirmarEliminacionFraccionA="confirmarEliminacionDescuento()"
    />
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
  </v-container>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import { mapActions, mapState } from "vuex";
import ModalDescuento from "@/components/modales/ModalDescuento.vue";
import ModalConfirmarEliminacion from "@/components/modales/ModalConfirmarEliminacion.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";

export default {
  data: () => ({
    mostrarErrorCarga: false,
    tableLoading: false,
    objetoDescuentoAEditar: {},
    search: "",
    dialogConfirmarEliminacion: false,
    dialogErrorEnAccion: false,
    mensajeErrorModalErrorEnAccion: "das",
    mostrarModalDescuento: false,
    idItemABorrar: null,
    snackbarExito: false,
    mensajeSnackbarExito: "",
    headers: [
      {
        text: "Descripción",
        align: "center",
        sortable: false,
        value: "DESCRIPCIÓN"
      },
      {
        text: "PRIORITY MENSAJERÍA",
        align: "center",
        sortable: false,
        value: "primaryMensajeria"
      },
      {
        text: "PRIORITY PAQUETERÍA",
        align: "center",
        sortable: false,
        value: "primaryPaqueteria"
      },
      {
        text: "ECONOMY MENSAJERÍA",
        align: "center",
        sortable: false,
        value: "economyMensajeria"
      },
      {
        text: "ECONOMY PAQUETERÍA",
        align: "center",
        sortable: false,
        value: "economyPaqueteria"
      },
      {
        text: "",
        align: "center",
        sortable: false,
        value: "actions"
      }
    ]
  }),
  components: {
    ModalDescuento,
    ModalConfirmarEliminacion,
    ModalErrorEnAccion
  },
  async beforeDestroy() {
    await this.destroyDescuentos();
  },
  async mounted() {
    await this.obtenerDescuentos();
  },
  computed: {
    ...mapState("tarifas", {
      descuentosList: state => state.descuentos
    }),
    ...mapState({
      logedInUserInfo: state => state.sesion.logedInUserInfo
    }),
  },
  methods: {
    ...mapActions("tarifas", ["getTarifas", "deleteTarifas", "destroyDescuentos"]),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    async obtenerDescuentos() {
      this.tableLoading = true;
      const res = await this.getTarifas();
      if (res[0]) {
        this.tableLoading = false;
        this.mostrarErrorCarga = false;
      } else if (res[1] === "errorcarga") {
        this.mostrarErrorCarga = true;
        this.tableLoading = false;
      }
    },
    cerrarModalDescuento() {
      this.mostrarModalDescuento = false;
      this.objetoDescuentoAEditar = {};
    },
    eliminarDescuento(data) {
      this.idItemABorrar = data;
      this.dialogConfirmarEliminacion = true;
    },
    async editarDescuentos(descuentoAEditar) {
      this.objetoDescuentoAEditar = descuentoAEditar;
      this.mostrarModalDescuento = true;
    },
    async confirmarEliminacionDescuento() {
      const res = await this.deleteTarifas(this.idItemABorrar);
      if (res[0]) {
        this.dialogConfirmarEliminacion = false;
        this.obtenerDescuentos();
        this.snackbarExito = true;
        this.mensajeSnackbarExito = "Descuento eliminado con éxito";
      } else {
        this.mensajeErrorModalErrorEnAccion = res[1];
        this.dialogErrorEnAccion = true;
        this.dialogConfirmarEliminacion = false;
      }
    },
    mostrarModalErrorEnAccion(mensaje) {
      this.dialogErrorEnAccion = true;
      this.mensajeErrorModalErrorEnAccion = mensaje;
    },
    mostrarDialogExito(mensaje) {
      this.cerrarModalDescuento();
      this.snackbarExito = true;
      this.mensajeSnackbarExito = mensaje;
      this.obtenerDescuentos();
    }
  }
};
</script>
<style lang="css" scoped></style>
